module.exports = __webpack_public_path__ + "static/footer.d595f515.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/footer.jpg
// module id = 344
// module chunks = 114276838955818